import { useState } from 'react'

import {
	EuiButtonEmpty,
	EuiPopover,
} from '@equipmentshare/ds2'

import ProcessingStatusActions from '../ProcessingStatusActions'

import { Transaction } from 'graphql'

export type ProcessingStatusPopoverProps = {
	label: string,
	openForm: () => void,
	transaction: Transaction,
}

export default function ProcessingStatusPopover( { label, transaction, openForm }: ProcessingStatusPopoverProps ) {
	const [ isOpen, setIsOpen ] = useState( false )

	const togglePopover = () => setIsOpen( !isOpen )
	const closePopover = () => setIsOpen( false )

	const onReceivePartsClick = () => {
		closePopover()
		openForm()
	}

	const button = (
		<EuiButtonEmpty
			id="status-btn"
			onClick={togglePopover}
		>
			{label}
		</EuiButtonEmpty>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isOpen}
			closePopover={closePopover}
		>
			<ProcessingStatusActions
				onReceivePartsClick={onReceivePartsClick}
				transaction={transaction}
			/>
		</EuiPopover>
	)
}
